module.exports = __webpack_public_path__ + "img/work_permit.f8f1e456.svg";